import React, { FC } from 'react'
import './content.scss'
interface IProps {
  children?: any;
  type: string;
}
const CouponItemCon: FC<IProps> = (props: IProps) => {
  const { children, type } = props
  return (
    <div className='coupon-discount-block'>
      <div className={`discount ${type}`}>
        <div className='discount-left'><div className='circle'></div><div className='circle'></div></div>
        <div className='discount-right'><div className='circle'></div><div className='circle'></div></div>
        {children}
      </div>
    </div>
  )
}
export default CouponItemCon
